import { styled, Box } from '@mui/material';

export const DashboardVariantV2CarrierZoneSaturationCollapseContent = styled(
  Box,
)(({ theme }) => ({
  padding: theme.spacing(1.5, 2),
  borderTop: `1px solid ${theme.palette.divider}`,
}));
